import { Link } from "react-router-dom";
import LogoMark from "./LogoMark";

const NAV = [
    { to: "/", label: "Home" },
    { to: "/about", label: "About" },
    { to: "/services", label: "Services" },
    { to: "/approach", label: "Our Approach" },
    { to: "/insights", label: "Insights" },
    { to: "/contact", label: "Contact" },
];

const AREAS = [
    "Strategy",
    "Sustainability",
    "ESG",
    "Governance",
    "Compliance",
    "Organisational Performance",
];

export default function Footer() {
    return (
        <footer className="border-t border-black/10 bg-paper text-ink" data-testid="site-footer">
            <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-24">
                <div className="grid grid-cols-1 gap-14 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <div className="flex flex-wrap items-center gap-4 text-ink">
                            <LogoMark className="h-12 w-auto md:h-14" />
                            <span className="text-2xl font-extrabold tracking-[0.06em] md:text-4xl">
                                ELCAYIL CONSULTING LTD.
                            </span>
                        </div>
                        <p className="mt-6 font-serif-d text-xl italic leading-snug text-ink/70 md:text-2xl">
                            Excellent in Performance.
                        </p>
                        <p className="mt-6 max-w-xs text-sm leading-relaxed text-ink/60">
                            Strategy | Sustainability | ESG | Governance |
                            Compliance | Organisational Performance
                        </p>
                    </div>

                    <div className="md:col-span-2">
                        <p className="eyebrow text-ink/50">Navigate</p>
                        <ul className="mt-6 space-y-3">
                            {NAV.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-link-${l.to === "/" ? "home" : l.to.slice(1)}`}
                                        className="text-sm text-ink/70 transition-colors duration-300 hover:text-brand"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-2">
                        <p className="eyebrow text-ink/50">Practice Areas</p>
                        <ul className="mt-6 space-y-3">
                            {AREAS.map((a) => (
                                <li
                                    key={a}
                                    className="text-sm text-ink/70"
                                    data-testid="footer-practice-area"
                                >
                                    {a}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="md:col-span-3">
                        <p className="eyebrow text-ink/50">Contact</p>
                        <address className="mt-6 space-y-3 text-sm not-italic leading-relaxed text-ink/70">
                            <p>
                                ELCAYIL CONSULTING LTD.
                                <br />
                                26 Northumberland Road
                                <br />
                                London, E6 5RN, United Kingdom
                            </p>
                            <p>
                                <a
                                    href="tel:+447961387639"
                                    data-testid="footer-phone-link"
                                    className="link-line"
                                >
                                    +44 796 138 7639
                                </a>
                            </p>
                            <p>
                                <a
                                    href="mailto:info@elcayilconsulting.co.uk"
                                    data-testid="footer-email-link"
                                    className="link-line"
                                >
                                    info@elcayilconsulting.co.uk
                                </a>
                            </p>
                            <p>
                                <a
                                    href="https://www.linkedin.com/in/shanualabi/"
                                    target="_blank"
                                    rel="noreferrer"
                                    data-testid="footer-linkedin-link"
                                    className="link-line"
                                >
                                    linkedin.com/in/shanualabi
                                </a>
                            </p>
                        </address>
                    </div>
                </div>

                <div className="mt-16 flex flex-col gap-3 border-t border-black/10 pt-8 text-xs text-ink/50 md:flex-row md:items-center md:justify-between">
                    <p data-testid="footer-copyright">
                        © 2026 ELCAYIL CONSULTING LTD. All Rights Reserved.
                    </p>
                    <p data-testid="footer-company-number">
                        Company No. 03615690 | elcayilconsulting.co.uk
                    </p>
                </div>
            </div>
        </footer>
    );
}
